shadow$provide[318] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Helpers:{enumerable:true, get:function() {
  return Helpers;
}}});
var UGLSL = require("../../util/glsl.js");
var UTicks = require("../../util/ticks.js");
var require$three = require("three");
const helpers = {bind:{make(slots) {
  if (this.bind == null) {
    this.bind = {};
  }
  if (this.bound == null) {
    this.bound = [];
  }
  for (const slot of Array.from(slots)) {
    let {callback} = slot;
    const {to, trait, optional, unique, multiple} = slot;
    if (callback == null) {
      callback = this.rebuild;
    }
    const name = to.split(/\./g).pop();
    const selector = this._get(to);
    let source = null;
    if (selector != null) {
      let start = this;
      let done = false;
      while (!done) {
        start = source = this._attach(selector, trait, callback, this, start, optional, multiple);
        const isUnique = unique && (source == null || this.bound.indexOf(source) < 0);
        done = multiple || optional || !unique || isUnique;
      }
    }
    if (source != null) {
      if (this.resize != null) {
        this._listen(source, "source.resize", this.resize);
      }
      if (callback) {
        this._listen(source, "source.rebuild", callback);
      }
      if (multiple) {
        for (const s of Array.from(source)) {
          this.bound.push(s);
        }
      } else {
        this.bound.push(source);
      }
    }
    this.bind[name] = source;
  }
  return null;
}, unmake() {
  if (!this.bind) {
    return;
  }
  delete this.bind;
  return delete this.bound;
},}, span:{make() {
  this.spanView = this._inherit("view");
  return this._listen("view", "view.range", () => this.trigger({type:"span.range"}));
}, unmake() {
  return delete this.spanView;
}, get:function() {
  const def = new require$three.Vector2(-1, 1);
  return function(prefix, dimension) {
    let left;
    const range = this._get(prefix + "span.range");
    if (range != null) {
      return range;
    }
    return (left = this.spanView != null ? this.spanView.axis(dimension) : undefined) != null ? left : def;
  };
}(),}, scale:{divide(prefix) {
  const divide = this._get(prefix + "scale.divide");
  const factor = this._get(prefix + "scale.factor");
  return Math.round(divide * 2.5 / factor);
}, generate(prefix, buffer, min, max) {
  const mode = this._get(prefix + "scale.mode");
  const divide = this._get(prefix + "scale.divide");
  const unit = this._get(prefix + "scale.unit");
  const base = this._get(prefix + "scale.base");
  const factor = this._get(prefix + "scale.factor");
  const start = this._get(prefix + "scale.start");
  const end = this._get(prefix + "scale.end");
  const zero = this._get(prefix + "scale.zero");
  const nice = this._get(prefix + "scale.nice");
  const ticks = UTicks.make(mode, min, max, divide, unit, base, factor, start, end, zero, nice);
  buffer.copy(ticks);
  return ticks;
},}, style:{uniforms() {
  return {styleColor:this.node.attributes["style.color"], styleOpacity:this.node.attributes["style.opacity"], styleZBias:this.node.attributes["style.zBias"], styleZIndex:this.node.attributes["style.zIndex"],};
},}, arrow:{uniforms() {
  const {start} = this.props;
  const {end} = this.props;
  const space = this._attributes.make(this._types.number(1.25 / (start + end)));
  const style = this._attributes.make(this._types.vec2(+start, +end));
  const size = this.node.attributes["arrow.size"];
  return {clipStyle:style, clipRange:size, clipSpace:space, arrowSpace:space, arrowSize:size,};
},}, point:{uniforms() {
  return {pointSize:this.node.attributes["point.size"], pointDepth:this.node.attributes["point.depth"],};
},}, line:{uniforms() {
  return {lineWidth:this.node.attributes["line.width"], lineDepth:this.node.attributes["line.depth"], lineProximity:this.node.attributes["line.proximity"],};
},}, surface:{uniforms() {
  return {};
},}, shade:{pipeline(shader) {
  if (!this._inherit("fragment")) {
    return shader;
  }
  if (shader == null) {
    shader = this._shaders.shader();
  }
  for (let pass = 0; pass <= 2; pass++) {
    shader = __guard__(this._inherit("fragment"), x => x.fragment(shader, pass));
  }
  shader.pipe("fragment.map.rgba");
  return shader;
}, normal(shader) {
  shader.pipe(UGLSL.swizzleVec4("xyz"));
  return shader;
}, map(shader) {
  if (!shader) {
    return shader;
  }
  return shader = this._shaders.shader().pipe("mesh.map.uvwo").pipe(shader);
},}, position:{pipeline(shader) {
  if (!this._inherit("vertex")) {
    return shader;
  }
  if (shader == null) {
    shader = this._shaders.shader();
  }
  for (let pass = 0; pass <= 3; pass++) {
    shader = __guard__(this._inherit("vertex"), x => x.vertex(shader, pass));
  }
  return shader;
}, swizzle(shader, order) {
  if (shader) {
    return this._shaders.shader().pipe(UGLSL.swizzleVec4(order)).pipe(shader);
  }
}, swizzle2(shader, order1, order2) {
  if (shader) {
    return this._shaders.shader().split().pipe(UGLSL.swizzleVec4(order1)).next().pipe(UGLSL.swizzleVec4(order2)).join().pipe(shader);
  }
},}, visible:{make() {
  const e = {type:"visible.change"};
  let visible = null;
  this.setVisible = function(vis) {
    if (vis != null) {
      visible = vis;
    }
    return onVisible();
  };
  const onVisible = () => {
    let left;
    const last = this.isVisible;
    let self = (left = visible != null ? visible : this._get("object.visible")) != null ? left : true;
    if (visibleParent != null) {
      if (self) {
        self = visibleParent.isVisible;
      }
    }
    this.isVisible = self;
    if (last !== this.isVisible) {
      return this.trigger(e);
    }
  };
  const visibleParent = this._inherit("visible");
  if (visibleParent) {
    this._listen(visibleParent, "visible.change", onVisible);
  }
  if (this.is("object")) {
    this._listen(this.node, "change:object", onVisible);
  }
  return onVisible();
}, unmake() {
  return delete this.isVisible;
},}, active:{make() {
  const e = {type:"active.change"};
  let active = null;
  this.setActive = function(act) {
    if (act != null) {
      active = act;
    }
    return onActive();
  };
  const onActive = () => {
    let left;
    const last = this.isActive;
    let self = (left = active != null ? active : this._get("entity.active")) != null ? left : true;
    if (activeParent != null) {
      if (self) {
        self = activeParent.isActive;
      }
    }
    this.isActive = self;
    if (last !== this.isActive) {
      return this.trigger(e);
    }
  };
  const activeParent = this._inherit("active");
  if (activeParent) {
    this._listen(activeParent, "active.change", onActive);
  }
  if (this.is("entity")) {
    this._listen(this.node, "change:entity", onActive);
  }
  return onActive();
}, unmake() {
  return delete this.isActive;
},}, object:{make(objects) {
  let blending, zOrder;
  if (objects == null) {
    objects = [];
  }
  this.objects = objects;
  this.renders = this.objects.reduce((a, b) => a.concat(b.renders), []);
  const objectScene = this._inherit("scene");
  let opacity = blending = zOrder = null;
  const hasStyle = Array.from(this.traits).includes("style");
  opacity = 1;
  blending = require$three.NormalBlending;
  let zWrite = true;
  let zTest = true;
  if (hasStyle) {
    ({opacity} = this.props);
    ({blending} = this.props);
    ({zOrder} = this.props);
    ({zWrite} = this.props);
    ({zTest} = this.props);
  }
  const onChange = event => {
    const {changed} = event;
    let refresh = null;
    if (changed["style.opacity"]) {
      refresh = opacity = this.props.opacity;
    }
    if (changed["style.blending"]) {
      refresh = blending = this.props.blending;
    }
    if (changed["style.zOrder"]) {
      refresh = zOrder = this.props.zOrder;
    }
    if (changed["style.zWrite"]) {
      refresh = zWrite = this.props.zWrite;
    }
    if (changed["style.zTest"]) {
      refresh = zTest = this.props.zTest;
    }
    if (refresh != null) {
      return onVisible();
    }
  };
  const onVisible = () => {
    const order = zOrder != null ? -zOrder : this.node.order;
    const visible = (this.isVisible != null ? this.isVisible : true) && opacity > 0;
    if (visible) {
      if (hasStyle) {
        return (() => {
          const result = [];
          for (const o of Array.from(this.objects)) {
            o.show(opacity < 1, blending, order);
            result.push(o.depth(zWrite, zTest));
          }
          return result;
        })();
      } else {
        return (() => {
          const result1 = [];
          for (const o of Array.from(this.objects)) {
            result1.push(o.show(true, blending, order));
          }
          return result1;
        })();
      }
    } else {
      return (() => {
        const result2 = [];
        for (const o of Array.from(this.objects)) {
          result2.push(o.hide());
        }
        return result2;
      })();
    }
  };
  this._listen(this.node, "change:style", onChange);
  this._listen(this.node, "reindex", onVisible);
  this._listen(this, "visible.change", onVisible);
  for (const object of Array.from(this.objects)) {
    objectScene.adopt(object);
  }
  return onVisible();
}, unmake(dispose) {
  let object;
  if (dispose == null) {
    dispose = true;
  }
  if (!this.objects) {
    return;
  }
  const objectScene = this._inherit("scene");
  for (object of Array.from(this.objects)) {
    objectScene.unadopt(object);
  }
  if (dispose) {
    return (() => {
      const result = [];
      for (object of Array.from(this.objects)) {
        result.push(object.dispose());
      }
      return result;
    })();
  }
}, mask() {
  let mask, shader;
  if (!(mask = this._inherit("mask"))) {
    return;
  }
  return shader = mask.mask(shader);
},}, unit:{make() {
  let focusDepth, pixelRatio, pixelUnit, renderAspect, renderHeight, renderOdd, renderScale, renderScaleInv, renderWidth, viewHeight, viewWidth, worldUnit;
  let \u03c0 = Math.PI;
  this.unitUniforms = {renderScaleInv:renderScaleInv = this._attributes.make(this._types.number(1)), renderScale:renderScale = this._attributes.make(this._types.number(1)), renderAspect:renderAspect = this._attributes.make(this._types.number(1)), renderWidth:renderWidth = this._attributes.make(this._types.number(0)), renderHeight:renderHeight = this._attributes.make(this._types.number(0)), viewWidth:viewWidth = this._attributes.make(this._types.number(0)), viewHeight:viewHeight = this._attributes.make(this._types.number(0)), 
  pixelRatio:pixelRatio = this._attributes.make(this._types.number(1)), pixelUnit:pixelUnit = this._attributes.make(this._types.number(1)), worldUnit:worldUnit = this._attributes.make(this._types.number(1)), focusDepth:focusDepth = this._attributes.make(this._types.number(1)), renderOdd:renderOdd = this._attributes.make(this._types.vec2()),};
  const top = new require$three.Vector3();
  const bottom = new require$three.Vector3();
  const handler = () => {
    let camera, size;
    if ((size = root != null ? root.getSize() : undefined) == null) {
      return;
    }
    \u03c0 = Math.PI;
    const {scale} = this.props;
    const {fov} = this.props;
    const focus = this.props.focus != null ? this.props.focus : this.inherit("unit").props.focus;
    const isAbsolute = scale === null;
    let measure = 1;
    if (camera = root != null ? root.getCamera() : undefined) {
      const m = camera.projectionMatrix;
      top.set(0, -0.5, 1).applyMatrix4(m);
      bottom.set(0, 0.5, 1).applyMatrix4(m);
      top.sub(bottom);
      measure = top.y;
    }
    const dpr = size.renderHeight / size.viewHeight;
    const fovtan = fov != null ? measure * Math.tan(fov * \u03c0 / 360) : 1;
    const pixel = isAbsolute ? dpr : size.renderHeight / scale * fovtan;
    const rscale = size.renderHeight * measure / 2;
    const world = pixel / rscale;
    viewWidth.value = size.viewWidth;
    viewHeight.value = size.viewHeight;
    renderWidth.value = size.renderWidth;
    renderHeight.value = size.renderHeight;
    renderAspect.value = size.aspect;
    renderScale.value = rscale;
    renderScaleInv.value = 1 / rscale;
    pixelRatio.value = dpr;
    pixelUnit.value = pixel;
    worldUnit.value = world;
    focusDepth.value = focus;
    return renderOdd.value.set(size.renderWidth % 2, size.renderHeight % 2).multiplyScalar(0.5);
  };
  const root = this.is("root") ? this : this._inherit("root");
  this._listen(root, "root.update", handler);
  return handler();
}, unmake() {
  return delete this.unitUniforms;
}, get() {
  const u = {};
  for (const k in this.unitUniforms) {
    const v = this.unitUniforms[k];
    u[k] = v.value;
  }
  return u;
}, uniforms() {
  return this.unitUniforms;
},},};
const Helpers = function(object, traits) {
  const h = {};
  for (const trait of Array.from(traits)) {
    let methods;
    if (!(methods = helpers[trait])) {
      continue;
    }
    h[trait] = {};
    for (const key in methods) {
      const method = methods[key];
      h[trait][key] = method.bind(object);
    }
  }
  return h;
};
function __guard__(value, transform) {
  return typeof value !== "undefined" && value !== null ? transform(value) : undefined;
}

};